import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  FormControl,
  Button,
  InputLabel,
  TextField,
  Select,
  SelectChangeEvent,
  OutlinedInput,
  Checkbox,
  FormControlLabel,
  CircularProgress,
  MenuItem,
  Paper,
} from '@mui/material'
import {
  AddShoppingCart,
  AttachMoney,
  Block,
  Check,
  CheckBox,
  CheckBoxOutlineBlank,
  CreditCard,
  Article,
  InfoOutlined,
  PictureAsPdfRounded,
  ReceiptOutlined,
  Search,
  Warning,
} from '@mui/icons-material'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import Moment from 'moment'
import ResponsiveAppBar from '../common/ResponsiveAppBar'
import React from 'react'
import ReactPaginate from 'react-paginate'
import { getDocumentUrlById, searchFinancial } from 'src/services/SearchService'
import { formatCurrency, formatDate } from '../utils/Formatter'
import '../Grid.css'
import ESDialog from 'src/common/ESDialog'
import { getClaimPaymentDetails } from 'src/services/ClaimService'
import { getBillOutPaymentDetails } from 'src/services/BillOutService'
import { PaymentDetailSummaryResult } from 'src/viewModels/PaymentDetailSummaryResult'
import { pagedList } from 'src/viewModels/pagedList'
import { FinancialResearchSummaryResult } from 'src/viewModels/FinancialResearchSummaryResult'
import { FinancialResearchSearchRequest } from 'src/viewModels/FinancialResearchSearchRequest'
import { Helmet } from 'react-helmet'
import { inject } from 'mobx-react'
import { IStores } from 'src/Stores'
import BundleClaimsModal from 'src/quotes/QuoteBills/BundleClaimsModal'
import ESMenu from 'src/common/ESMenu'
import AppealLogModal from './AppealLogModal'
import AppealNameConstants from 'src/constants/AppealNameConstants'
import AppealNoteModal from './AppealNoteModal'
import { GetComponentOptions } from 'src/services/LookupService'
import { AppealType } from 'src/utils/AppealType'
import ClaimLastUpdateHistoryModal from './ClaimLastUpdateHistoryModal'
import MarkClaimDeletedModal from './MarkClaimDeletedModal'
import { ClaimHeaderDetailsSummaryResult } from 'src/viewModels/ClaimHeaderDetailsSummaryResult'
import SortedTableCell, { sortedTableHeaderSx } from '../workflow/SortedTableCell'

interface IResearchProps {
  openBillsDialogById?: (eocId: string, quoteId: string, altTitle: string) => void
  setParentRefreshWithBundle?: (setRefresh: boolean) => void
  buildResearchMenuItems?: (record: FinancialResearchSummaryResult) => any[]
  openAppealLogModal?: (claimId: string) => void
  closeAppealLogModal?: () => void
  openAppealNoteModal?: (claimId: string) => void
  openLastUpdateHistoryModal?: (claimId: string) => void
  closeAppealNoteModal?: () => void
  closeLastHistoryModal?: () => void
  closeMarkClaimDeleteModal?: () => void
  selectedClaimId?: string
  isAppealLogModalOpen?: boolean
  isAppealNoteModalOpen?: boolean
  isLastHistoryModalOpen?: boolean
  isMarkClaimDeletedModalOpen?: boolean
  selectedPatientHeader: ClaimHeaderDetailsSummaryResult
  setUpdateParentStateAfterModal: (parentFunction: () => void) => void
  savedOrder?: string | undefined
  savedOrderBy?: string | undefined
  setSavedSort?: (order: string | undefined, orderBy: string | undefined) => void
}
class FinancialResearch extends React.Component<IResearchProps> {
  public async componentDidMount() {
    var result = await GetComponentOptions(true, true)
    this.props.setParentRefreshWithBundle!(false)
    this.props.setUpdateParentStateAfterModal(this.getFinancialResearchData)
    this.setState({
      searchStatus: this.state.searchComponents,
      componentNameDict: result,
    })
  }

  private setPaginationOffsetData = () => {
    const { page, totalItems, pageSize } = this.state
    const firstRecordIndex = (page - 1) * pageSize + 1
    const lastRecordIndex = page * pageSize < totalItems ? page * pageSize : totalItems
    this.setState({
      firstRecordIndex: firstRecordIndex,
      lastRecordIndex: lastRecordIndex,
    })
  }

  private getFinancialResearchData = async () => {
    this.setState({ gridLoading: true })
    const {
      page,
      pageSize,
      searchClaimStatus,
      searchBillOutStatus,
      searchPatientFirstName,
      searchPatientLastName,
      sortColumn,
      sortOrder,
    } = this.state
    var received = undefined
    const selectComponents = Array.from(this.state.searchComponents.keys())

    if (
      this.state.receivedCheckNumber != '' &&
      this.state.receivedCheckNumber.trim().length > 0
    ) {
      received = true
    } else if (
      this.state.sentCheckNumber != '' &&
      this.state.sentCheckNumber.trim().length > 0
    ) {
      received = false
    }

    const data: FinancialResearchSearchRequest = {
      patientFirstName: searchPatientFirstName,
      patientLastName: searchPatientLastName,
      claimStatus: searchClaimStatus,
      billOutStatus: searchBillOutStatus,
      components: selectComponents,
      checkNumber:
        this.state.searchCheckNumber.trim().length == 0
          ? ''
          : this.state.searchCheckNumber,
      serviceDateStart: this.state.searchServiceDateStart,
      serviceDateEnd: this.state.searchServiceDateEnd,
      checkDateStart: this.state.searchCheckDateStart,
      checkDateEnd: this.state.searchCheckDateEnd,
      showAppeals: this.state.searchShowAppeals,
      receivedChecks: received,
      eocGeneratedLegacyNumber: this.state.eocGeneratedLegacyNumber,
      groupNumber: this.state.groupNumber,
      quoteGroupNumber:
        this.state.quoteGroupNumber != ''
          ? Number(this.state.quoteGroupNumber)
          : undefined,
      page: page,
      pageSize: pageSize,
      sorting: sortColumn ? { column: sortColumn, order: sortOrder } : undefined,
    }
    await searchFinancial(data).then((response: any) => {
      this.setState(
        {
          gridData: response.items,
          pageCount: response.totalPages,
          totalItems: response.totalItems,
          gridLoading: false,
        },
        () => {
          this.setPaginationOffsetData()
        }
      )
    })
  }

  private handlePageChange = (event: any) => {
    const page = event.selected
    this.setState({ page: page + 1 }, () => this.getFinancialResearchData())
  }

  private isSearchGridDataEmpty = () => {
    return this.state.totalItems == 0
  }

  private isDialogGridDataEmpty = () => {
    return (
      this.state.modalData.lineItems == undefined ||
      this.state.modalData.lineItems.length == 0
    )
  }

  private close = () => {
    this.setState({ detailDialogOpen: false })
  }

  private showClaimPayments = async (claimId: string, appealType: number) => {
    this.setState({ detailDialogTitle: 'Pay Provider Details' })
    this.setState({ detailAmountTotalLabel: 'Total Contract:' })
    this.setState({ detailAmountColumnName: 'Contract Amount' })
    this.setState({ appealType: appealType })
    this.setState({ dialogIcon: <AttachMoney /> })
    await getClaimPaymentDetails(claimId).then((_response: any) => {
      this.setState({ modalData: _response })
      this.setState({ detailDialogOpen: true })
    })
  }

  private showbillOutPayments = async (billOutId: string) => {
    this.setState({ detailDialogTitle: 'Receive Payment Details' })
    this.setState({ detailAmountTotalLabel: 'Total Amt Billed:' })
    this.setState({ detailAmountColumnName: 'Amt Billed' })
    this.setState({ dialogIcon: <CreditCard /> })
    await getBillOutPaymentDetails(billOutId).then((_response: any) => {
      this.setState({ modalData: _response })
      this.setState({ detailDialogOpen: true })
    })
  }

  private renderContextMenu = (record: FinancialResearchSummaryResult, index: number) => {
    let options = this.props.buildResearchMenuItems!(record)

    return (
      <ESMenu
        data={record}
        menuItems={options}
        rowIndex={index}
        menuAriaLabel={`$quote-${index}-menu`}
      />
    )
  }

  public getLineItemStyle = (status: string) => {
    if (status !== undefined && status === 'Deleted') {
      return { textDecoration: 'line-through red' }
    } else {
      return undefined
    }
  }

  public sort = (columnName: string) => {
    this.setState(
      {
        sortColumn: columnName,
        sortOrder: this.state.sortOrder == 'asc' ? 'desc' : 'asc',
        gridLoading: true,
        page: 1,
      },
      () => {
        this.props.setSavedSort?.(this.state.sortOrder, this.state.sortColumn)
        this.getFinancialResearchData().catch(() => {})
      }
    )
  }

  private renderSortedHeaderIfNotNewlyAdded = (
    columnName: string,
    propertyName: string,
    align?: any,
    style?: React.CSSProperties
  ) => {
    const hasData = !!this.state.gridData && this.state.gridData.length > 0
    return (
      <SortedTableCell
        columnName={columnName}
        propertyName={propertyName}
        align={align}
        style={style}
        order={this.state.sortOrder}
        orderBy={this.state.sortColumn}
        onClick={this.sort}
        sortable={hasData}
        reserveSortIconSpace
      />
    )
  }

  private mapSearchGridData = () => {
    if (this.isSearchGridDataEmpty()) {
      return (
        <TableRow className="gridNoPadding" key={1}>
          <TableCell colSpan={14} align="center">
            No records found
          </TableCell>
        </TableRow>
      )
    } else {
      const eocWidth = Math.max(
        ...this.state.gridData.map((x) => (x.eocGeneratedOrLegacyId ?? '').length)
      )
      return this.state.gridData.map((record, index) => (
        <TableRow className="gridPadding" key={index}>
          <TableCell
            style={{
              whiteSpace: 'nowrap',
              paddingRight: '3px',
              paddingLeft: '3px',
            }}
          >
            {record.hasProviderPayment ? (
              <>
                <Tooltip title="Show Pay Provider Details">
                  <AttachMoney
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      this.showClaimPayments(record.claimId!, record.appealType!)
                    }}
                  />
                </Tooltip>
                &nbsp;&nbsp;
              </>
            ) : (
              <>
                <AttachMoney style={{ visibility: 'hidden' }} />
                &nbsp;&nbsp;
              </>
            )}
            {record.appealType == AppealType.OverpaidProvider ||
            (record.billOutId && record.claimStatus !== 'Deleted') ? (
              <>
                <Tooltip title="Show Received Payment Details">
                  <CreditCard
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      if (record.appealType == AppealType.OverpaidProvider) {
                        this.showClaimPayments(record.claimId!, record.appealType!)
                      } else {
                        this.showbillOutPayments(record.billOutId!)
                      }
                    }}
                  />
                </Tooltip>
                &nbsp;&nbsp;
              </>
            ) : (
              <>
                <CreditCard style={{ visibility: 'hidden' }} />
                &nbsp;&nbsp;
              </>
            )}
            {record.inGlobal && record.eocId && record.quoteId ? (
              <>
                <Tooltip
                  title={
                    record.isConsumedClaim
                      ? `Show Consumer Bundle Details (Quote Type: ${record.quoteType}, Group #: ${record.quoteGroupNumber})`
                      : `Show Bundle Details (Quote Type: ${record.quoteType}, Group #: ${record.quoteGroupNumber})`
                  }
                >
                  <AddShoppingCart
                    style={{ cursor: 'pointer' }}
                    color={record.isConsumedClaim ? 'warning' : 'inherit'}
                    onClick={() => {
                      this.props.openBillsDialogById!(
                        record.eocId!,
                        record.quoteId!,
                        record.eocGeneratedOrLegacyId
                      )
                    }}
                  />
                </Tooltip>
                &nbsp;&nbsp;
              </>
            ) : (
              <AddShoppingCart style={{ visibility: 'hidden' }} />
            )}
          </TableCell>
          <TableCell
            sx={this.getLineItemStyle(record.claimStatus!)}
            style={{
              whiteSpace: 'nowrap',
              paddingRight: '3px',
              paddingLeft: '3px',
            }}
          >
            <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <span
                style={{
                  minWidth: `${eocWidth}ch`,
                  fontVariantNumeric: 'tabular-nums',
                }}
              >
                {record.eocGeneratedOrLegacyId}
              </span>
              <span style={{ display: 'inline-flex' }}>
                {record.appealType != undefined ? (
                  <Tooltip
                    title={`Appeal Type: ${AppealNameConstants[record.appealType]}`}
                  >
                    <InfoOutlined fontSize="small" />
                  </Tooltip>
                ) : (
                  <></>
                )}
                {record.claimId &&
                record.lastAppealDate &&
                record.appealType === undefined ? (
                  <Tooltip title={'View Appeal Log'}>
                    <ReceiptOutlined
                      style={{ cursor: 'pointer' }}
                      fontSize="small"
                      onClick={() => {
                        this.props.openAppealLogModal!(record.claimId!)
                        this.setState({ groupInfo: record.eocGeneratedOrLegacyId })
                      }}
                    />
                  </Tooltip>
                ) : (
                  <></>
                )}
              </span>
            </span>
          </TableCell>
          <TableCell
            sx={this.getLineItemStyle(record.claimStatus!)}
            style={{ paddingRight: '3px', paddingLeft: '3px' }}
          >
            {record.patientName}
          </TableCell>
          <TableCell
            sx={this.getLineItemStyle(record.claimStatus!)}
            align="right"
            style={{ paddingRight: '8px', paddingLeft: '3px' }}
          >
            {formatDate(record.dateOfService)}
          </TableCell>
          <TableCell
            sx={this.getLineItemStyle(record.claimStatus!)}
            style={{ paddingRight: '8px', paddingLeft: '3px' }}
          >
            {record.type}
          </TableCell>
          <TableCell
            sx={this.getLineItemStyle(record.claimStatus!)}
            align="right"
            style={{ paddingRight: '8px', paddingLeft: '3px' }}
          >
            {record.dateReceived != '' ? formatDate(record.dateReceived!) : ''}
          </TableCell>
          <TableCell
            sx={this.getLineItemStyle(record.claimStatus!)}
            style={{ paddingRight: '3px', paddingLeft: '3px' }}
          >
            {record.component}
          </TableCell>
          <TableCell
            sx={this.getLineItemStyle(record.claimStatus!)}
            style={{ paddingRight: '3px', paddingLeft: '3px' }}
          >
            {record.claimStatus}&nbsp;&nbsp;
            {record.currentEOBDocumentId != undefined &&
            (record.claimStatus?.toLowerCase().includes('paid') ||
              record.claimStatus?.toLowerCase().includes('denied')) ? (
              <Tooltip title="Show Latest Explanation of Payment">
                <PictureAsPdfRounded
                  fontSize="small"
                  style={{ cursor: 'pointer' }}
                  onClick={async () =>
                    window.open(await getDocumentUrlById(record.currentEOBDocumentId!))
                  }
                />
              </Tooltip>
            ) : (
              <></>
            )}
            {record.currentDenialDocumentId != undefined &&
            record.claimStatus?.toLowerCase() === 'denied' ? (
              <Tooltip title="Show Latest Denial Documentation">
                <Article
                  fontSize="small"
                  color="error"
                  style={{ cursor: 'pointer' }}
                  onClick={async () =>
                    window.open(await getDocumentUrlById(record.currentDenialDocumentId!))
                  }
                />
              </Tooltip>
            ) : (
              <></>
            )}
          </TableCell>
          <TableCell
            sx={this.getLineItemStyle(record.claimStatus!)}
            style={{ paddingRight: '3px', paddingLeft: '3px' }}
          >
            {record.billOutStatus}
          </TableCell>
          <Tooltip title={record.providerLocation || ''}>
            <TableCell
              sx={this.getLineItemStyle(record.claimStatus!)}
              style={{
                paddingRight: '3px',
                paddingLeft: '3px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                maxWidth: '150px',
              }}
            >
              {record.providerLocation}
            </TableCell>
          </Tooltip>
          <TableCell
            align="right"
            sx={this.getLineItemStyle(record.claimStatus!)}
            style={{ paddingRight: '8px', paddingLeft: '3px' }}
          >
            {formatCurrency(record.totalCharges)}
          </TableCell>
          <TableCell
            sx={this.getLineItemStyle(record.claimStatus!)}
            align="right"
            style={{
              paddingRight: '3px',
              paddingLeft: '3px',
              color:
                record.appealType != undefined &&
                record.appealType === AppealType.OverpaidProvider
                  ? 'red'
                  : 'inherit',
            }}
          >
            {record.totalContractAmountDisplay != undefined
              ? record.totalContractAmountDisplay
              : ''}
          </TableCell>
          <TableCell
            sx={this.getLineItemStyle(record.claimStatus!)}
            align="right"
            style={{ paddingRight: '3px', paddingLeft: '3px' }}
          >
            {record.totalBilledOutAmount != undefined
              ? formatCurrency(record.totalBilledOutAmount)
              : ''}
          </TableCell>
          <TableCell style={{ paddingRight: '3px', paddingLeft: '3px' }}>
            {this.renderContextMenu(record, index)}
          </TableCell>
        </TableRow>
      ))
    }
  }

  private mapDialogGridData = () => {
    if (this.isDialogGridDataEmpty()) {
      return (
        <TableRow className="gridNoPadding" key={1}>
          <TableCell colSpan={13} align="center">
            No records found
          </TableCell>
        </TableRow>
      )
    } else {
      return this.state.modalData.lineItems.map((record, index) => (
        <TableRow className="gridPaddingDense" key={index}>
          {this.state.detailDialogTitle == 'Pay Provider Details' ? (
            <TableCell>
              {record.pendingCheck ? (
                <Tooltip title="Holding">
                  <Warning style={{ color: '#ffc107' }} />
                </Tooltip>
              ) : (
                <></>
              )}
            </TableCell>
          ) : (
            <></>
          )}
          <TableCell
            sx={record.voidedCheck ? { textDecoration: 'line-through red' } : undefined}
            style={{ paddingLeft: '30px' }}
            align="right"
          >
            {formatDate(record.checkDate!)}
          </TableCell>
          <TableCell
            sx={record.voidedCheck ? { textDecoration: 'line-through red' } : undefined}
          >
            {record.checkNumber}
          </TableCell>
          {this.state.detailDialogTitle == 'Receive Payment Details' ? (
            <TableCell
              sx={record.voidedCheck ? { textDecoration: 'line-through red' } : undefined}
            >
              {record.payer}
            </TableCell>
          ) : (
            <></>
          )}
          <TableCell>{record.refund ? <Check color="error" /> : <></>}</TableCell>
          <TableCell>{record.voidedCheck ? <Block color="error" /> : <></>}</TableCell>
          <TableCell
            sx={record.voidedCheck ? { textDecoration: 'line-through red' } : undefined}
            align="right"
          >
            {formatDate(record.appliedDatePaid!)}
          </TableCell>
          <TableCell
            sx={record.voidedCheck ? { textDecoration: 'line-through red' } : undefined}
          >
            {record.appliedBy!}
          </TableCell>
          {this.state.detailDialogTitle == 'Pay Provider Details' ? (
            <>
              <TableCell
                sx={
                  record.voidedCheck ? { textDecoration: 'line-through red' } : undefined
                }
              >
                {record.modifiedOn ? formatDate(record.modifiedOn.toString()) : 'N/A'}
              </TableCell>
              <TableCell
                sx={
                  record.voidedCheck ? { textDecoration: 'line-through red' } : undefined
                }
              >
                {record.modifiedBy ?? 'N/A'}
              </TableCell>
            </>
          ) : (
            <></>
          )}
          <TableCell
            sx={record.voidedCheck ? { textDecoration: 'line-through red' } : undefined}
            align="right"
          >
            {formatDate(record.dateOfService!)}
          </TableCell>
          <TableCell
            sx={record.voidedCheck ? { textDecoration: 'line-through red' } : undefined}
            align="right"
          >
            {record.lineNumber}
          </TableCell>
          <TableCell
            sx={record.voidedCheck ? { textDecoration: 'line-through red' } : undefined}
          >
            {record.cptCode}
          </TableCell>
          <TableCell
            sx={record.voidedCheck ? { textDecoration: 'line-through red' } : undefined}
            align="right"
          >
            {record.amount != undefined ? formatCurrency(record.amount) : ''}
          </TableCell>
          <TableCell
            sx={record.voidedCheck ? { textDecoration: 'line-through red' } : undefined}
            align="right"
            style={{
              color:
                record.amountPaid != undefined && Number(record.amountPaid) < 0
                  ? 'red'
                  : 'inherit',
            }}
          >
            {record.amountPaid != undefined ? record.amountPaidDisplay : ''}
          </TableCell>
          {this.state.detailDialogTitle == 'Receive Payment Details' ? (
            <></>
          ) : (
            <TableCell
              sx={record.voidedCheck ? { textDecoration: 'line-through red' } : undefined}
            >
              {record.reasonCode}
            </TableCell>
          )}
        </TableRow>
      ))
    }
  }

  private paginationInfo = () => {
    if (!this.isSearchGridDataEmpty()) {
      return (
        <div className="pagination">
          <Typography variant="caption" gutterBottom>
            Showing {this.state.firstRecordIndex} to {this.state.lastRecordIndex} of{' '}
            {this.state.totalItems} entries
          </Typography>
        </div>
      )
    } else {
      return <></>
    }
  }

  private search = (event: any) => {
    this.setState({ page: 1 }, () => {
      if (this.state.specialChars) {
        return
      } else if (
        (this.state.searchBillOutStatus != undefined &&
          this.state.searchBillOutStatus != '') ||
        (this.state.searchServiceDateStart != undefined &&
          this.state.searchServiceDateStart != '') ||
        (this.state.searchServiceDateEnd != undefined &&
          this.state.searchServiceDateEnd != '') ||
        (this.state.searchCheckDateEnd != undefined &&
          this.state.searchCheckDateEnd != '') ||
        this.state.eocGeneratedLegacyNumber != '' ||
        this.state.groupNumber != '' ||
        (this.state.searchCheckDateStart != undefined &&
          this.state.searchCheckDateStart != '') ||
        this.state.searchCheckNumber != '' ||
        (this.state.searchClaimStatus != undefined &&
          this.state.searchClaimStatus != '') ||
        this.state.searchComponents.size > 0 ||
        this.state.searchPatientFirstName != '' ||
        this.state.searchPatientLastName != '' ||
        this.state.searchShowAppeals == true
      ) {
        this.getFinancialResearchData()
      } else {
        this.setState({
          gridData: undefined,
          pageCount: 0,
          totalItems: 0,
          gridLoading: false,
          noFilters: true,
        })
      }
    })
    event.preventDefault()
  }

  private clearSearch = () => {
    var select_box = document.getElementById('claimStatus') as HTMLSelectElement
    if (select_box != undefined) {
      select_box.selectedIndex = 0
    }

    var select_box2 = document.getElementById('billoutStatus') as HTMLSelectElement
    if (select_box2 != undefined) {
      select_box2.selectedIndex = 0
    }

    var serviceStart = document.getElementById('serviceStartDate') as HTMLInputElement
    if (serviceStart != undefined) {
      serviceStart.value = ''
    }
    var serviceEnd = document.getElementById('serviceEndDate') as HTMLInputElement
    if (serviceEnd != undefined) {
      serviceEnd.value = ''
    }

    var start = document.getElementById('startDate') as HTMLInputElement
    if (start != undefined) {
      start.value = ''
    }
    var end = document.getElementById('endDate') as HTMLInputElement
    if (end != undefined) {
      end.value = ''
    }
    this.setState({
      searchClaimStatus: undefined,
      searchBillOutStatus: undefined,
      searchPatientFirstName: '',
      searchPatientLastName: '',
      searchCheckNumber: '',
      searchServiceDateStart: undefined,
      searchServiceDateEnd: undefined,
      searchCheckDateStart: undefined,
      searchCheckDateEnd: undefined,
      receivedCheckNumber: '',
      sentCheckNumber: '',
      eocGeneratedLegacyNumber: '',
      groupNumber: '',
      quoteGroupNumber: '',
      searchShowAppeals: false,
      searchComponents: new Map<string, string>(),
      gridData: undefined,
      pageCount: 0,
      totalItems: 0,
      gridLoading: false,
      noFilters: false,
    })
  }

  private handleClaimStatusChange = (event: any) => {
    this.setState({ searchClaimStatus: event.target.value, noFilters: false })
  }

  private handleBillOutStatusChange = (event: any) => {
    this.setState({
      searchBillOutStatus: event.target.value,
      noFilters: false,
    })
  }

  private handlePatientFirstNameChange = (event: any) => {
    this.setState({
      searchPatientFirstName: event.target.value,
      noFilters: false,
    })
  }

  private handlePatientLastNameChange = (event: any) => {
    this.setState({
      searchPatientLastName: event.target.value,
      noFilters: false,
    })
  }

  private handleReceivedCheckChange = (event: any) => {
    this.setState({
      receivedCheckNumber: event.target.value,
      searchCheckNumber: event.target.value,
      sentCheckNumber: '',
      noFilters: false,
    })
  }

  private handleSentCheckChange = (event: any) => {
    this.setState({
      sentCheckNumber: event.target.value,
      searchCheckNumber: event.target.value,
      receivedCheckNumber: '',
      noFilters: false,
    })
  }

  private handleServiceStartDateChange = (date: any) => {
    this.setState({
      searchServiceDateStart: date ? Moment(date).format('YYYY-MM-DD') : '',
      noFilters: false,
    })
  }

  private handleServiceEndDateChange = (date: any) => {
    this.setState({
      searchServiceDateEnd: date ? Moment(date).format('YYYY-MM-DD') : '',
      noFilters: false,
    })
  }

  private handleStartDateChange = (date: any) => {
    this.setState({
      searchCheckDateStart: date ? Moment(date).format('YYYY-MM-DD') : '',
      noFilters: false,
    })
  }

  private handleEndDateChange = (date: any) => {
    this.setState({
      searchCheckDateEnd: date ? Moment(date).format('YYYY-MM-DD') : '',
      noFilters: false,
    })
  }

  private handleEOCLegacyChange = (event: any) => {
    this.setState({
      eocGeneratedLegacyNumber: event.target.value,
      noFilters: false,
    })
  }

  private handleGroupNumberChange = (event: any) => {
    var val = String(event.target.value)
    var nan = val.includes('-') || val.includes('.')

    this.setState({ groupNumber: val, noFilters: false, specialChars: nan })
  }

  private handleQuoteGroupNumberChange = (event: any) => {
    var val = String(event.target.value)
    var nan = val.includes('-') || val.includes('.')

    this.setState({
      quoteGroupNumber: val,
      noFilters: false,
      quoteGroupSpecialChars: nan,
    })
  }

  private handleShowAppealsChange = (_event: React.ChangeEvent, value: boolean) => {
    this.setState({ searchShowAppeals: value, noFilters: false })
  }

  private handleComponentChange = (event: SelectChangeEvent<string[]>) => {
    const selectedIds = event.target.value as string[]
    const newComponents = new Map<string, string>()

    // Rebuild the map with selected items
    selectedIds.forEach((id) => {
      const item = this.state.componentNameDict?.find((c) => c.id === id)
      if (item && item.id && item.description) {
        newComponents.set(item.id, item.description)
      }
    })

    this.setState({
      searchComponents: newComponents,
      noFilters: false,
    })
  }

  public state = {
    searchClaimStatus: undefined,
    searchBillOutStatus: undefined,
    searchPatientFirstName: '',
    searchPatientLastName: '',
    searchCheckNumber: '',
    searchServiceDateStart: undefined,
    searchServiceDateEnd: undefined,
    searchCheckDateStart: undefined,
    searchCheckDateEnd: undefined,
    searchShowAppeals: false,
    searchComponents: new Map<string, string>(),
    receivedCheckNumber: '',
    sentCheckNumber: '',
    eocGeneratedLegacyNumber: '',
    groupNumber: '',
    quoteGroupNumber: '',
    detailDialogOpen: false,
    detailDialogTitle: '',
    detailAmountTotalLabel: '',
    detailAmountColumnName: '',
    dialogIcon: <AttachMoney />,
    gridData: new pagedList().items as FinancialResearchSummaryResult[],
    modalData: new PaymentDetailSummaryResult(),
    page: 1,
    pageCount: 0,
    firstRecordIndex: 0,
    lastRecordIndex: 0,
    totalItems: 0,
    pageSize: 20,
    gridLoading: false,
    componentNameDict: new Array<{ id: string; description: string }>(),
    groupInfo: '',
    appealType: undefined,
    noFilters: false,
    specialChars: false,
    quoteGroupSpecialChars: false,
    sortColumn: '',
    sortOrder: 'asc',
  }

  public render() {
    const MenuProps = {
      getContentAnchorEl: null,
      PaperProps: {
        style: {
          maxHeight: 400,
        },
      },
    }
    return (
      <>
        <ResponsiveAppBar title="Financial Research" pageIcon={<Search />} />
        <Helmet>
          <title>Financial Research</title>
        </Helmet>
        <Paper
          style={{
            margin: '3px',
            height: '100%',
            paddingBottom: '20px',
          }}
        >
          <Grid container style={{ width: '100%', paddingBottom: '20px' }}>
            {this.props.selectedClaimId && this.props.isAppealLogModalOpen ? (
              <AppealLogModal
                claimId={this.props.selectedClaimId}
                isOpen={this.props.isAppealLogModalOpen}
                closeModal={this.props.closeAppealLogModal!}
                groupInfo={this.state.groupInfo}
              />
            ) : (
              <></>
            )}
            {this.props.selectedClaimId && this.props.isLastHistoryModalOpen ? (
              <ClaimLastUpdateHistoryModal
                claimId={this.props.selectedClaimId}
                isOpen={this.props.isLastHistoryModalOpen}
                closeModal={this.props.closeLastHistoryModal!}
              />
            ) : (
              <></>
            )}
            {this.props.selectedClaimId && this.props.isAppealNoteModalOpen ? (
              <AppealNoteModal
                claimId={this.props.selectedClaimId}
                isOpen={this.props.isAppealNoteModalOpen}
                closeModal={this.props.closeAppealNoteModal!}
              />
            ) : (
              <></>
            )}
            <BundleClaimsModal showButtons={false} />
            {this.state.gridLoading && (
              <div
                style={{
                  position: 'fixed',
                  display: 'flex',
                  width: '100%',
                  height: '100%',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(0, 0, 0, 0.5)',
                  cursor: 'pointer',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: '2',
                }}
              >
                <CircularProgress size={100} />
              </div>
            )}
            {this.props.selectedClaimId &&
            this.props.isMarkClaimDeletedModalOpen &&
            this.props.selectedPatientHeader ? (
              <MarkClaimDeletedModal
                open={this.props.isMarkClaimDeletedModalOpen}
                CMS1500Id={this.props.selectedClaimId!}
                cancel={this.props.closeMarkClaimDeleteModal!}
              />
            ) : (
              <></>
            )}
            <form onSubmit={this.search}>
              <Grid
                container
                style={{ margin: '10px 0px', paddingLeft: '30px', width: '100%' }}
                xs={12}
              >
                <Typography
                  color="primary"
                  component="h6"
                  variant="h6"
                  gutterBottom
                  style={{ paddingBottom: '10px' }}
                >
                  SEARCH CRITERIA
                </Typography>
                <Grid container style={{ width: '100%' }} direction="row" spacing={2}>
                  <Grid item xs={3}>
                    <FormControl fullWidth>
                      <TextField
                        value={this.state.searchPatientFirstName}
                        onChange={this.handlePatientFirstNameChange}
                        variant="outlined"
                        label="Patient First Name"
                        name="searchPatientFirstName"
                        InputLabelProps={{ shrink: true }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={3}>
                    <FormControl fullWidth>
                      <TextField
                        value={this.state.searchPatientLastName}
                        onChange={this.handlePatientLastNameChange}
                        label="Patient Last Name"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{ fullWidth: true }}
                        variant="outlined"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={3}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel
                        shrink={true}
                        htmlFor="claim-status-select"
                        variant="outlined"
                      >
                        Claim Status
                      </InputLabel>
                      <Select
                        value={this.state.searchClaimStatus}
                        id="claimStatus"
                        onChange={this.handleClaimStatusChange}
                        variant="outlined"
                        input={
                          <OutlinedInput
                            notched
                            id="claim-status-select"
                            name="claimStatus"
                            label="Claim Status"
                          />
                        }
                        native={true}
                        fullWidth
                      >
                        <option value=""></option>
                        <option value="Contract TBD">Contract TBD</option>
                        <option value="Deleted">Deleted</option>
                        <option value="Denied">Denied</option>
                        <option value="Denied-Holding">Denied-Holding</option>
                        <option value="Draft">Draft</option>
                        <option value="Dismissed Refund">Dismissed Refund</option>
                        <option value="Imported">Imported</option>
                        <option value="Imported Denied">Imported Denied</option>
                        <option value="Imported Paid">Imported Paid</option>
                        <option value="Imported Received">Imported Received</option>
                        <option value="Needs Denied">Needs Denied</option>
                        <option value="Paid">Paid</option>
                        <option value="Paid-Holding">Paid-Holding</option>
                        <option value="Received">Received</option>
                        <option value="Refunded">Refunded</option>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={2}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel
                        htmlFor="billout-status-select"
                        shrink={true}
                        variant="outlined"
                      >
                        Bill-Out Status
                      </InputLabel>
                      <Select
                        value={this.state.searchBillOutStatus}
                        onChange={this.handleBillOutStatusChange}
                        variant="outlined"
                        input={
                          <OutlinedInput
                            notched
                            name="billOutStatus"
                            id="billout-status-select"
                            label="Bill-Out Status"
                          />
                        }
                        native={true}
                        id="billoutStatus"
                        fullWidth
                      >
                        <option value=""></option>
                        <option value="Billed Out">Billed Out</option>
                        <option value="Dismissed">Dismissed</option>
                        <option value="Dismissed w/ Balance">Dismissed w/ Balance</option>
                        <option value="Imported">Imported</option>
                        <option value="Imported Billed Out">Imported Billed Out</option>
                        <option value="Imported Paid">Imported Paid</option>
                        <option value="Paid">Paid</option>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={2}>
                    <FormControl fullWidth>
                      <TextField
                        value={this.state.eocGeneratedLegacyNumber}
                        onChange={this.handleEOCLegacyChange}
                        label="EOC/Legacy"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{ fullWidth: true }}
                        variant="outlined"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={1}>
                    <FormControl fullWidth>
                      <TextField
                        error={this.state.specialChars}
                        value={this.state.groupNumber}
                        onChange={this.handleGroupNumberChange}
                        label="Group #"
                        type="number"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{ fullWidth: true }}
                        variant="outlined"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={1} style={{ paddingRight: '170px' }}>
                    <FormControl>
                      <FormControlLabel
                        label="Only Show Appeals"
                        labelPlacement="end"
                        control={
                          <Checkbox
                            checked={this.state.searchShowAppeals}
                            onChange={this.handleShowAppealsChange}
                            inputProps={{
                              id: 'show-appeals-filter',
                            }}
                            value="searchShowAppeals"
                            name="searchShowAppeals"
                          />
                        }
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={3}>
                    {this.state.componentNameDict && (
                      <FormControl fullWidth variant="outlined">
                        <InputLabel shrink={true} variant="outlined">
                          Component
                        </InputLabel>
                        <Select
                          variant="outlined"
                          input={<OutlinedInput notched label="Component" />}
                          fullWidth
                          id="componentNameDict"
                          multiple
                          value={Array.from(this.state.searchComponents.keys())}
                          renderValue={() =>
                            Array.from(this.state.searchComponents.values()).join(', ')
                          }
                          onChange={this.handleComponentChange as any}
                          MenuProps={MenuProps}
                        >
                          {this.state.componentNameDict.map((item) => (
                            <MenuItem value={item.id} data-name={item.description}>
                              {item.id && this.state.searchComponents.has(item.id) ? (
                                <CheckBox
                                  color="secondary"
                                  style={{ paddingRight: '10px' }}
                                />
                              ) : (
                                <CheckBoxOutlineBlank
                                  color="action"
                                  style={{ paddingRight: '10px' }}
                                />
                              )}{' '}
                              {item.description}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  </Grid>
                  <Grid item container xs={4} direction="row" spacing={1}>
                    <Grid item xs={4}>
                      <DatePicker
                        onChange={this.handleServiceStartDateChange}
                        value={
                          this.state.searchServiceDateStart
                            ? Moment(this.state.searchServiceDateStart)
                            : null
                        }
                        label="Date of Service Start"
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            variant: 'outlined',
                            InputLabelProps: { shrink: true },
                          },
                          openPickerIcon: { fontSize: 'small' },
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <strong> - </strong>
                    </Grid>
                    <Grid item xs={4}>
                      <DatePicker
                        onChange={this.handleServiceEndDateChange}
                        value={
                          this.state.searchServiceDateEnd
                            ? Moment(this.state.searchServiceDateEnd)
                            : null
                        }
                        label="Date of Service End"
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            variant: 'outlined',
                            InputLabelProps: { shrink: true },
                          },
                          openPickerIcon: { fontSize: 'small' },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container item xs={12} spacing={2}>
                    <Grid item xs={2}>
                      <FormControl fullWidth>
                        <TextField
                          value={this.state.receivedCheckNumber}
                          onChange={this.handleReceivedCheckChange}
                          disabled={this.state.sentCheckNumber != ''}
                          label="Received Check #"
                          InputLabelProps={{ shrink: true }}
                          InputProps={{ fullWidth: true }}
                          variant="outlined"
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={2}>
                      <FormControl fullWidth>
                        <TextField
                          value={this.state.sentCheckNumber}
                          disabled={this.state.receivedCheckNumber != ''}
                          onChange={this.handleSentCheckChange}
                          label="Sent Check #"
                          InputLabelProps={{ shrink: true }}
                          InputProps={{ fullWidth: true }}
                          variant="outlined"
                        />
                      </FormControl>
                    </Grid>
                    <Grid item container xs="auto" direction="row" spacing={1}>
                      <Grid item style={{ width: '170px' }}>
                        <DatePicker
                          onChange={this.handleStartDateChange}
                          value={
                            this.state.searchCheckDateStart
                              ? Moment(this.state.searchCheckDateStart)
                              : null
                          }
                          label="Check Start Date"
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              variant: 'outlined',
                              InputLabelProps: { shrink: true },
                            },
                            openPickerIcon: { fontSize: 'small' },
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <strong> - </strong>
                      </Grid>
                      <Grid item style={{ width: '170px' }}>
                        <DatePicker
                          onChange={this.handleEndDateChange}
                          value={
                            this.state.searchCheckDateEnd
                              ? Moment(this.state.searchCheckDateEnd)
                              : null
                          }
                          label="Check End Date"
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              variant: 'outlined',
                              InputLabelProps: { shrink: true },
                            },
                            openPickerIcon: { fontSize: 'small' },
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={1}>
                      <FormControl fullWidth>
                        <TextField
                          error={this.state.quoteGroupSpecialChars}
                          value={this.state.quoteGroupNumber}
                          onChange={this.handleQuoteGroupNumberChange}
                          label="Quote Group #"
                          type="number"
                          InputLabelProps={{ shrink: true }}
                          InputProps={{ fullWidth: true }}
                          variant="outlined"
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    direction="row"
                    spacing={2}
                    style={{
                      width: '50%',
                      marginLeft: '1px',
                      paddingBottom: '10px',
                      paddingTop: '10px',
                    }}
                  >
                    <Grid item>
                      <Button
                        type="submit"
                        color="primary"
                        size="medium"
                        variant="contained"
                      >
                        Search
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        color="secondary"
                        onClick={this.clearSearch}
                        size="medium"
                        variant="contained"
                      >
                        Clear Search
                      </Button>
                    </Grid>
                    {this.state.noFilters && (
                      <Grid item>
                        <div
                          style={{ textAlign: 'right', margin: '10px 20px 12px' }}
                          className="error"
                        >
                          At least one filter is required to search.
                        </div>
                      </Grid>
                    )}
                    {this.state.specialChars && (
                      <Grid item>
                        <div
                          style={{ textAlign: 'right', margin: '10px 20px 12px' }}
                          className="error"
                        >
                          Group # must be a positive whole number.
                        </div>
                      </Grid>
                    )}
                    {this.state.quoteGroupSpecialChars && (
                      <Grid item>
                        <div
                          style={{ textAlign: 'right', margin: '10px 20px 12px' }}
                          className="error"
                        >
                          Quote Group # must be a positive whole number.
                        </div>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </form>
            <ESDialog
              close={this.close}
              open={this.state.detailDialogOpen}
              title={
                `${this.state.detailDialogTitle} -
                        ${this.state.modalData.patientName} (${this.state.modalData.patientDob})` +
                (this.state.modalData.groupNumber
                  ? ` ${this.state.modalData.groupNumber}`
                  : '')
              }
              titleIcon={this.state.dialogIcon}
              showSaveButton={false}
              maxWidth="xl"
            >
              {({}) => (
                <Grid container direction="row" style={{ marginTop: '5px' }} spacing={2}>
                  <Grid item>
                    <Grid container direction="row" spacing={1}>
                      <Grid item>
                        <strong>Billing Address:</strong>
                      </Grid>
                      <Grid item>
                        {this.state.modalData.billingAddress
                          ? this.state.modalData.billingAddress
                          : '{UNKNOWN}'}
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item>
                    <Grid container direction="row" spacing={2}>
                      <Grid item>
                        <strong>{this.state.detailAmountTotalLabel}</strong>
                      </Grid>
                      <Grid item>
                        {this.state.modalData.totalAmount != undefined
                          ? formatCurrency(this.state.modalData.totalAmount)
                          : ''}
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item>
                    <Grid container direction="row" spacing={2}>
                      <Grid item>
                        <strong>Total Paid:</strong>
                      </Grid>
                      <Grid
                        item
                        style={{
                          paddingRight: '0px',
                          color:
                            this.state.appealType === AppealType.OverpaidProvider
                              ? 'red'
                              : 'inherit',
                        }}
                      >
                        {this.state.modalData.totalPaidDisplay}
                      </Grid>
                    </Grid>
                  </Grid>
                  {this.state.appealType != undefined ? (
                    <Grid item>
                      <Tooltip
                        title={`Appeal Type: ${
                          AppealNameConstants[this.state.appealType]
                        }`}
                      >
                        <InfoOutlined fontSize="small" />
                      </Tooltip>
                    </Grid>
                  ) : (
                    <></>
                  )}
                  <Grid
                    item
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignContent="center"
                    alignItems="flex-start"
                    wrap="wrap"
                  >
                    <Grid item xs={12}>
                      <Table
                        className="gridPaddingDense"
                        aria-label="simple table"
                        style={{ padding: '20' }}
                      >
                        <TableHead style={{ paddingLeft: '2px', paddingRight: '2px' }}>
                          <TableRow>
                            {this.state.detailDialogTitle == 'Pay Provider Details' ? (
                              <TableCell></TableCell>
                            ) : (
                              <></>
                            )}
                            <TableCell align="right">Check Date</TableCell>
                            <TableCell>Check Number</TableCell>
                            {this.state.detailDialogTitle == 'Receive Payment Details' ? (
                              <TableCell>Payer</TableCell>
                            ) : (
                              <></>
                            )}
                            <TableCell>Refund</TableCell>
                            <TableCell>Voided</TableCell>
                            {this.state.detailDialogTitle == 'Receive Payment Details' ? (
                              <TableCell align="right">Applied Date</TableCell>
                            ) : (
                              <TableCell align="right">Created</TableCell>
                            )}
                            {this.state.detailDialogTitle == 'Receive Payment Details' ? (
                              <TableCell>Applied By</TableCell>
                            ) : (
                              <TableCell>Created By</TableCell>
                            )}
                            {this.state.detailDialogTitle == 'Pay Provider Details' ? (
                              <>
                                <TableCell>Modified</TableCell>
                                <TableCell>Modified By</TableCell>
                              </>
                            ) : (
                              <></>
                            )}
                            <TableCell align="right">Date of Service</TableCell>
                            <TableCell align="right">Line#</TableCell>
                            <TableCell>CPT Code</TableCell>
                            <TableCell align="right">
                              {this.state.detailAmountColumnName}
                            </TableCell>
                            <TableCell align="right">Amount Paid</TableCell>

                            {this.state.detailDialogTitle == 'Receive Payment Details' ? (
                              <></>
                            ) : (
                              <TableCell>Reason Code</TableCell>
                            )}
                          </TableRow>
                        </TableHead>
                        <TableBody style={{ width: '100%' }}>
                          {this.mapDialogGridData()}
                        </TableBody>
                      </Table>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </ESDialog>
            <Grid item xs={12} style={{ width: '1500px' }}>
              <Table
                className="gridPaddingDense"
                aria-label="simple table"
                sx={sortedTableHeaderSx}
                style={{ padding: '20' }}
              >
                <TableHead style={{ paddingLeft: '2px', paddingRight: '2px' }}>
                  <TableRow style={{ paddingLeft: '2px', paddingRight: '2px' }}>
                    <TableCell
                      style={{ paddingLeft: '3px', paddingRight: '3px' }}
                    ></TableCell>
                    {this.renderSortedHeaderIfNotNewlyAdded(
                      'EOC/Legacy',
                      'EOCGeneratedOrLegacyId',
                      undefined,
                      { whiteSpace: 'nowrap', paddingLeft: '3px', paddingRight: '3px' }
                    )}
                    {this.renderSortedHeaderIfNotNewlyAdded(
                      'Patient',
                      'PatientName',
                      undefined,
                      { whiteSpace: 'nowrap', paddingLeft: '3px', paddingRight: '3px' }
                    )}
                    {this.renderSortedHeaderIfNotNewlyAdded(
                      'Date of Service',
                      'DateOfService',
                      'right',
                      { whiteSpace: 'nowrap', paddingLeft: '3px', paddingRight: '8px' }
                    )}
                    {this.renderSortedHeaderIfNotNewlyAdded(
                      'EOC Status',
                      'Type',
                      undefined,
                      { whiteSpace: 'nowrap', paddingLeft: '3px', paddingRight: '3px' }
                    )}
                    {this.renderSortedHeaderIfNotNewlyAdded(
                      'Date Rcv',
                      'DateReceived',
                      'right',
                      { whiteSpace: 'nowrap', paddingLeft: '3px', paddingRight: '8px' }
                    )}
                    {this.renderSortedHeaderIfNotNewlyAdded(
                      'Component',
                      'Component',
                      undefined,
                      { whiteSpace: 'nowrap', paddingLeft: '3px', paddingRight: '3px' }
                    )}
                    {this.renderSortedHeaderIfNotNewlyAdded(
                      'Claim Status',
                      'ActualClaimDbStatus',
                      undefined,
                      { whiteSpace: 'nowrap', paddingLeft: '3px', paddingRight: '3px' }
                    )}
                    {this.renderSortedHeaderIfNotNewlyAdded(
                      'Bill Out Status',
                      'ActualBillOutDbStatus',
                      undefined,
                      { whiteSpace: 'nowrap', paddingLeft: '3px', paddingRight: '3px' }
                    )}
                    {this.renderSortedHeaderIfNotNewlyAdded(
                      'Claim Provider Location',
                      'ProviderLocation',
                      undefined,
                      { whiteSpace: 'nowrap', paddingLeft: '3px', paddingRight: '3px' }
                    )}
                    {this.renderSortedHeaderIfNotNewlyAdded(
                      'Total Charges',
                      'TotalCharges',
                      'right',
                      { whiteSpace: 'nowrap', paddingLeft: '3px', paddingRight: '3px' }
                    )}
                    {this.renderSortedHeaderIfNotNewlyAdded(
                      'Total Contract Amt',
                      'TotalContractAmount',
                      'right',
                      { whiteSpace: 'nowrap', paddingLeft: '3px', paddingRight: '3px' }
                    )}
                    {this.renderSortedHeaderIfNotNewlyAdded(
                      'Total Billed Out',
                      'TotalBilledOutAmount',
                      'right',
                      { whiteSpace: 'nowrap', paddingLeft: '3px', paddingRight: '3px' }
                    )}
                    <TableCell
                      style={{ paddingLeft: '3px', paddingRight: '3px' }}
                    ></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody style={{ width: '10%' }}>{this.mapSearchGridData()}</TableBody>
              </Table>
              <div className="pagination-row">
                {this.paginationInfo()}
                <ReactPaginate
                  previousLabel={'<'}
                  nextLabel={'>'}
                  onPageChange={this.handlePageChange}
                  forcePage={this.state.page - 1}
                  pageCount={this.state.pageCount}
                  containerClassName={'pagination'}
                  activeClassName={'active'}
                  //@ts-ignore
                  renderOnZeroPageCount={null}
                />
              </div>
            </Grid>
          </Grid>
        </Paper>
      </>
    )
  }
}

const InjectedResearch = inject<IStores, IResearchProps, Partial<IResearchProps>, any>(
  (stores: IStores) => ({
    openBillsDialogById: stores.quotes.openBillsDialogById,
    setParentRefreshWithBundle: stores.quotes.setParentRefreshWithBundle,
    buildResearchMenuItems: stores.cms1500.buildResearchMenuItems,
    openAppealLogModal: stores.cms1500.OpenAppealLogModal,
    closeAppealLogModal: stores.cms1500.closeAppealLogModal,
    isAppealLogModalOpen: stores.cms1500.isAppealLogModalOpen,
    openAppealNoteModal: stores.cms1500.openAppealNoteModal,
    closeAppealNoteModal: stores.cms1500.closeAppealNoteModal,
    isAppealNoteModalOpen: stores.cms1500.isAppealNoteModalOpen,
    isLastHistoryModalOpen: stores.cms1500.isLastUpdateHistoryModalOpen,
    closeLastHistoryModal: stores.cms1500.closeLastUpdateHistoryModal,
    selectedClaimId: stores.cms1500.selectedClaimId,
    openLastUpdateHistoryModal: stores.cms1500.openLastUpdateHistoryModal,
    isMarkClaimDeletedModalOpen: stores.cms1500.isMarkClaimDeletedModalOpen,
    closeMarkClaimDeleteModal: stores.cms1500.closeMarkClaimDeleteModal,
    selectedPatientHeader: stores.cms1500.headerDetails,
    setUpdateParentStateAfterModal: stores.cms1500.setParentUpdateFunction,
  })
)(FinancialResearch)

export default InjectedResearch
